module.exports = __webpack_public_path__ + "static/media/reverse-lg.44582ef7.svg";